// src/components/common/FormField.jsx
import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Tooltip } from "react-tooltip";

const FormField = ({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder = "",
  tooltip = "",
  options = [],
  min,
  max,
  step,
  className = "",
  width = 6,
  disabled = false,
  required = false,
  rows = 3,
  ...props
}) => {
  const InfoTooltip = ({ tooltipId, content }) => (
    <>
      {/* <AiOutlineInfoCircle
        data-tooltip-id={tooltipId}
        data-tooltip-content={content}
        style={{
          marginLeft: "6px",
          cursor: "help",
          color: "#6B7280",
          fontSize: "14px",
          verticalAlign: "middle",
          opacity: 0.7,
        }}
      />
      <Tooltip
        id={tooltipId}
        place="top"
        style={{
          background: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(12px)",
          color: "#374151",
          fontSize: "11px",
          fontWeight: "500",
          borderRadius: "4px",
          maxWidth: "400px",
          padding: "14px 18px",
          lineHeight: "1.6",
          zIndex: 10000,
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
        }}
      /> */}
      <AiOutlineInfoCircle
        title={content}
        style={{
          marginLeft: "4px",
          cursor: "help",
          color: "#6B7280",
          fontSize: "16px",
          verticalAlign: "middle",
          display: "inline-flex",
          alignItems: "center",
        }}
      />
    </>
  );

  const inputStyle = {
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    padding: "8px 12px",
    backgroundColor: "#ffffff",
  };

  const renderInput = () => {
    switch (type) {
      case "radio":
        return (
          <div className="d-flex gap-3 flex-wrap">
            {options.map((option) => (
              <div key={option.value} className="form-check">
                <Input
                  type="radio"
                  name={id}
                  id={`${id}-${option.value}`}
                  value={option.value}
                  checked={value === option.value}
                  onChange={(e) => onChange(e.target.value)}
                  className="form-check-input"
                  disabled={disabled}
                />
                <Label
                  htmlFor={`${id}-${option.value}`}
                  className="form-check-label"
                >
                  {option.label}
                  {option.tooltip && (
                    <InfoTooltip
                      tooltipId={`${id}-tooltip`}
                      content={option.tooltip}
                    />
                  )}
                </Label>
              </div>
            ))}
          </div>
        );

      case "checkbox":
        return (
          <div className="form-check">
            <Input
              type="checkbox"
              id={id}
              checked={value || false}
              onChange={(e) => onChange(e.target.checked)}
              className="form-check-input"
              disabled={disabled}
            />
            <Label htmlFor={id} className="form-check-label">
              {label}
              {tooltip && (
                <InfoTooltip tooltipId={`${id}-tooltip`} content={tooltip} />
              )}
            </Label>
          </div>
        );

      case "textarea":
        return (
          <Input
            type="textarea"
            id={id}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            style={{ ...inputStyle, minHeight: "80px" }}
            disabled={disabled}
            rows={rows}
            {...props}
          />
        );

      default:
        return (
          <Input
            type={type}
            id={id}
            value={value || ""}
            onChange={(e) => {
              let newValue = e.target.value;
              if (type === "number") {
                newValue =
                  e.target.value === "" ? "" : parseFloat(newValue) || 0;
              }
              onChange(newValue);
            }}
            placeholder={placeholder}
            min={min}
            max={max}
            step={step}
            style={inputStyle}
            disabled={disabled}
            {...props}
          />
        );
    }
  };

  return (
    <FormGroup className={`mb-3 ${className}`}>
      {type !== "checkbox" && (
        <Label
          htmlFor={id}
          style={{
            fontSize: "14px",
            fontWeight: "500",
            color: "#374151",
            marginBottom: "6px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {label}
          {required && (
            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
          )}
          :
          {tooltip && (
            <InfoTooltip tooltipId={`${id}-tooltip`} content={tooltip} />
          )}
        </Label>
      )}
      {renderInput()}
    </FormGroup>
  );
};

export default FormField;
